/**
 * ****************************************************************************
 * @description     :   Store data and process common will use in page dashboard
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – namnth@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

const MSG_NO_DATA = '該当するデータが存在しません。';

const createSchedule = () => ({
    no: '',
    start_date: '',
    person_in_charge: '',
    filename: '',
    file_path: '',
    file: '',
    note: '',
    showImage: false,
    disable: { start_date: false, person_in_charge: false, note: false }
});

const createInitialData = () => ({
    type: '1',
    company_cd: '',
    company_nm: '',
    md_name: '',
    mdcd: 0,
    work_report_id: 0,
    tab_no: 1,
    client_cd: '',
    client_nm: '',
    branch_cd: '',
    branch_nm: '',
    visit_date: '',
    report_date: '',
    sales_matter_content: [],
    report_content: '',
    reporting_filename: '',
    reporting_file: '',
    purchasing_people: [createSchedule()],
    visit_reports: []
});

const createPagination = () => ({
    pageNo: 1,
    pageSize: 10,
    totalRows: 0,
    msgNoData: MSG_NO_DATA
});

export default {
    namespaced: true,
    state: {
        data: createInitialData(),
        paginationData: createPagination(),
        optionGroup: {
            sales_matter_content: [
                { code: 1, name: '名刺交換' },
                { code: 2, name: '担当者情報更新' },
                { code: 3, name: '資料共有' },
                { code: 4, name: 'TSR確認' },
                { code: 5, name: '与信確認' },
                { code: 6, name: '営業メモ' },
                { code: 7, name: '営業注意事項' },
                { code: 8, name: '社内共有' }
            ],
            pageSize: [
                { code: 10, name: '10件' },
                { code: 50, name: '50件' },
                { code: 100, name: '100件' }
            ]
        }
    },
    mutations: {
        resetFormData(state, type) {
            state.data = createInitialData();
            state.data.type = type;
            state.paginationData = createPagination();
        },
        initForm(state, data) {
            state.data = JSON.parse(JSON.stringify(data || createInitialData()));
            const totalRows = state.data.visit_reports?.length || 0;
            state.paginationData = {
                pageNo: 1,
                pageSize: 10,
                totalRows,
                msgNoData: totalRows === 0 ? MSG_NO_DATA : ''
            };
        }
    },
    actions: {}
};
